import type { AnimationControls, Variants } from 'framer-motion';
import { motion } from 'framer-motion';

import { type AnimatedIconHandle, withAnimatedIcon } from './withAnimatedIcon';

type MessageCircleQuestionIconRenderProps = {
  controls: AnimationControls;
  size: number;
};

const groupVariants: Variants = {
  normal: {
    rotate: 0,
  },
  animate: {
    rotate: [0, 8, -8, 2, 0],
    transition: {
      ease: 'easeInOut',
      duration: 0.8,
      times: [0, 0.4, 0.6, 0.8, 1],
    },
  },
};

const questionMarkVariants: Variants = {
  normal: {
    y: 0,
  },
  animate: {
    y: [0, 1, -0.25, 0],
    transition: {
      ease: 'easeInOut',
      duration: 0.8,
      times: [0, 0.4, 0.7, 1],
    },
  },
};

const MessageCircleQuestionIconRender = ({
  controls,
  size,
}: MessageCircleQuestionIconRenderProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <motion.g
      variants={groupVariants}
      animate={controls}
      style={{ transformOrigin: 'bottom left' }}
    >
      <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
      <motion.path
        d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
        variants={questionMarkVariants}
        animate={controls}
      />
      <path d="M12 17h.01" />
    </motion.g>
  </svg>
);

export type MessageCircleQuestionIconHandle = AnimatedIconHandle;

export const MessageCircleQuestionIcon = withAnimatedIcon(
  MessageCircleQuestionIconRender,
  'MessageCircleQuestionIcon',
);
